import React, { FC, useContext, useState } from 'react'
import Button from '../../common/Button/Button'
import WholeSaleForm from '../../forms/WholeSaleForm/WholeSaleForm'
import MaxWidth from '../../layout/MaxWidth/MaxWidth'
import FormModal from '../../modals/FormModal'
import { ButtonTheme } from '../../types'
import Plates from './Plates/Plates'
import css from './Wholesale.module.scss'
import ArrowIcon from '../../../public/static/icons/arrow-left.svg'
import CartIcon from '../../../public/static/icons/cart.svg'
import { WholesaleContext } from '../../../contexts/wholesaleProvider'

const WholesalePage: FC = () => {
  const [isFormOpen, setIsFormOpen] = useState(false)
  const { page } = useContext(WholesaleContext)
  return (
    <>
      <MaxWidth>
        <section className={css.wrapper}>
          <div>
            <h1 className={css.title}>{page.title}</h1>
            {page.description && (
              <p className={css.description}>{page.description}</p>
            )}
          </div>
          <div className={css.form}>
            <WholeSaleForm className={css.form_wrapper} />

            <Button
              onClick={() => setIsFormOpen(true)}
              className={css.button}
              theme={ButtonTheme.ellipseBig}
            >
              Оставить заявку
            </Button>
          </div>
        </section>
      </MaxWidth>
      <MaxWidth mobileWide>
        <Plates />
      </MaxWidth>

      <FormModal open={isFormOpen}>
        <div className={css.modal_wrapper}>
          <div className={css.modal_top}>
            <button
              className={css.button_arrow}
              type="button"
              onClick={() => setIsFormOpen(false)}
            >
              <ArrowIcon />
            </button>

            <CartIcon />
          </div>
          <WholeSaleForm />
        </div>
      </FormModal>
    </>
  )
}

export default WholesalePage
